// Ad trackers (Meta, TikTok, Google/YouTube) — each no-ops when its ID is missing.
export const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const TIKTOK_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || "";
const GADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";
const GADS_LABEL = process.env.REACT_APP_GOOGLE_ADS_PURCHASE_LABEL || "";
const UTM_KEY = "sf_utm";
let INITIALIZED = false;

const addScript = (src) => {
    const s = document.createElement("script");
    s.async = true;
    s.src = src;
    document.head.appendChild(s);
};

function initMeta() {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
}

function initTikTok() {
    const ttq = (window.ttq = window.ttq || []);
    ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
    ttq.setAndDefer = (t, e) => { t[e] = (...a) => { t.push([e, ...a]); }; };
    ttq.methods.forEach((m) => ttq.setAndDefer(ttq, m));
    addScript(`https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${TIKTOK_ID}&lib=ttq`);
    ttq.page();
}

function initGoogle() {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GADS_ID);
}

function captureUtm() {
    const p = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content"].forEach((k) => { if (p.get(k)) utm[k] = p.get(k).slice(0, 100); });
    if (Object.keys(utm).length) localStorage.setItem(UTM_KEY, JSON.stringify(utm));
}

export const getUtm = () => {
    try { return JSON.parse(localStorage.getItem(UTM_KEY) || "{}"); } catch { return {}; }
};

export function initPixel() {
    if (INITIALIZED || typeof window === "undefined") return;
    INITIALIZED = true;
    captureUtm();
    if (PIXEL_ID) initMeta();
    if (TIKTOK_ID) initTikTok();
    if (GADS_ID) initGoogle();
}

const TIKTOK_EVENTS = { Lead: "SubmitForm", InitiateCheckout: "InitiateCheckout", Purchase: "CompletePayment", ViewContent: "ViewContent" };

export function pixelTrack(event, params = {}, eventId) {
    if (typeof window === "undefined") return;
    try {
        if (PIXEL_ID && window.fbq) window.fbq("track", event, params, eventId ? { eventID: eventId } : undefined);
        if (TIKTOK_ID && window.ttq) window.ttq.track(TIKTOK_EVENTS[event] || event, params, eventId ? { event_id: eventId } : undefined);
        if (GADS_ID && window.gtag && event === "Purchase" && GADS_LABEL) {
            window.gtag("event", "conversion", { send_to: `${GADS_ID}/${GADS_LABEL}`, value: params.value, currency: params.currency, transaction_id: eventId });
        }
    } catch { /* ignore */ }
}

export const PixelEvents = {
    lead: (source) => pixelTrack("Lead", { content_name: source }),
    initiateCheckout: (plan, value) => pixelTrack("InitiateCheckout", { content_name: plan, value, currency: "EUR" }),
    purchase: (plan, value, sessionId) => {
        const key = `sf_purchase_${sessionId}`;
        if (sessionId && localStorage.getItem(key)) return;
        pixelTrack("Purchase", { content_name: plan, value, currency: "EUR" }, sessionId);
        if (sessionId) localStorage.setItem(key, "1");
    },
    viewContent: (name) => pixelTrack("ViewContent", { content_name: name }),
};
